export default defineNuxtRouteMiddleware((from, to) => {
  if (to.path !== from.path && process.client) {
    // Keep hash targets intact — app.vue scrolls to them after page finish
    if (to.hash) return;

    // Immediately scroll to top
    window.scrollTo(0, 0);

    // Also set scroll position after a small delay to handle any async content
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }
});
